export const NodeStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DESTROYED: "DESTROYED",
} as const;

export type NodeStatus = (typeof NodeStatus)[keyof typeof NodeStatus];
